import VehicleCard from 'Components/shared/VehicleCards/VehicleCard/VehicleCard';
import VehicleCardContextAndRTBWrapper from 'Components/shared/VehicleCards/VehicleCard/VehicleCardContextAndRTBWrapper';
import VehicleCardView from 'Components/shared/VehicleCards/VehicleCard/VehicleCardView/VehicleCardView';
import ROUTES from 'Utilities/routes';

import type { SimilarVehicleCardProps } from './SimilarVehiclesCard.types';

import styles from './SimilarVehiclesCard.module.scss';

export const SimilarVehiclesCard: React.FC<SimilarVehicleCardProps> = ({
	maxImageWidth,
	onShortlisted,
	onVehicleCardClick,
	vehicle,
}) => {
	const url = ROUTES.VEHICLE.as(vehicle.id);

	// 512px is the max width of the card as set in CSS
	const imageWidth = maxImageWidth ?? 512;

	return (
		<VehicleCard className={styles.card} onClick={() => onVehicleCardClick?.(vehicle.id, url)} vehicle={vehicle}>
			<VehicleCardContextAndRTBWrapper vehicle={vehicle}>
				{/* @ts-ignore expects props provided by HOC */}
				<VehicleCardView
					className={styles.cardView}
					displayShortListButton={true}
					imageWidth={imageWidth}
					onClickShortlist={({ id, isChecked }) => onShortlisted?.(id, url, isChecked)}
					page={'vehicle details'}
				/>
			</VehicleCardContextAndRTBWrapper>
		</VehicleCard>
	);
};
